// pages/HomePageV2.jsx
// Page d'accueil V2 avec 8 blocs opérationnels

import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { BookOpen, TrendingUp, PenTool, Wand2, BookMarked, ListMusic } from 'lucide-react';
import './HomePage.css';

export default function HomePageV2() {
  const { t } = useTranslation();

  return (
    <div className="home-page">
      <div className="welcome-card">
        <h2>{t('home.bienvenue')}</h2>
        <p className="welcome-subtitle">{t('home.sousTitre')}</p>

        <div className="operations-grid">
          {/* Exercices de Conjugaison */}
          <Link to="/exercice-conjugaison-partielle" className="operation-card conjugaison">
            <div className="card-icon">
              <PenTool size={32} color="#4F46E5" />
            </div>
            <h3>{t('home.conjugaisonTitre')}</h3>
            <p>{t('home.conjugaisonDesc')}</p>
          </Link>

          {/* Exercices de Conjugaison Complète */}
          <Link to="/exercice-conjugaison-complete" className="operation-card conjugaison-complete">
            <div className="card-icon">
              <BookOpen size={32} color="#10B981" />
            </div>
            <h3>{t('home.conjugaisonCompleteTitre')}</h3>
            <p>{t('home.conjugaisonCompleteDesc')}</p>
          </Link>

          {/* Analyse de Texte */}
          <Link to="/analyse" className="operation-card analyse">
            <div className="card-icon">
              <BookOpen size={32} color="#F59E0B" />
            </div>
            <h3>{t('home.analyseTitre')}</h3>
            <p>{t('home.analyseDesc')}</p>
          </Link>

          {/* Exercice Matching */}
          <Link to="/exercice-matching" className="operation-card matching">
            <div className="card-icon">
              <Wand2 size={32} color="#8B5CF6" />
            </div>
            <h3>{t('home.matchingTitre')}</h3>
            <p>{t('home.matchingDesc')}</p>
          </Link>

          {/* Quiz Vocabulaire */}
          <Link to="/exercice-quiz-vocabulaire" className="operation-card quiz">
            <div className="card-icon">
              <BookMarked size={32} color="#EF4444" />
            </div>
            <h3>{t('home.quizVocabulaireTitre')}</h3>
            <p>{t('home.quizVocabulaireDesc')}</p>
          </Link>

          {/* Quiz Grammaire */}
          <Link to="/exercice-quiz-grammaire" className="operation-card quiz">
            <div className="card-icon">
              <BookMarked size={32} color="#EF4444" />
            </div>
            <h3>{t('home.quizGrammaireTitre')}</h3>
            <p>{t('home.quizGrammaireDesc')}</p>
          </Link>

          {/* Niveau */}
          <Link to="/changer-niveau" className="operation-card niveau">
            <div className="card-icon">
              <TrendingUp size={32} color="#06B6D4" />
            </div>
            <h3>{t('home.niveauTitre')}</h3>
            <p>{t('home.niveauDesc')}</p>
          </Link>

          {/* Playlists */}
          <Link to="/playlists" className="operation-card playlists">
            <div className="card-icon">
              <ListMusic size={32} color="#84CC16" />
            </div>
            <h3>{t('home.playlistsTitre')}</h3>
            <p>{t('home.playlistsDesc')}</p>
          </Link>
        </div>

        <div className="home-footer">
          <p>{t('home.footer')}</p>
        </div>
      </div>
    </div>
  );
}
